"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVenue = getVenue;
exports.getDepartment = getDepartment;
exports.findPositionById = findPositionById;
exports.getPosition = getPosition;
exports.getPositionColorFromDepartment = getPositionColorFromDepartment;
exports.getPositionColor = getPositionColor;
const colors_1 = require("../colors");
function getVenue(venues, venueId) {
    return venues.find(({ id }) => id === venueId) || null;
}
function getDepartment(venues, id) {
    if (id == null) {
        return { department: null, venue: null };
    }
    for (const venue of venues) {
        for (const department of [...venue.departments, ...venue.archivedDepartments]) {
            if (department.id === id) {
                return { department, venue };
            }
        }
    }
    return { venue: null, department: null };
}
function findPositionById(venues, id) {
    for (const venue of venues) {
        for (const department of [...venue.departments, ...venue.archivedDepartments]) {
            const position = [...department.positions, ...department.archivedPositions].find((r) => r.id === id);
            if (position) {
                return {
                    venue,
                    department,
                    position,
                };
            }
        }
    }
    return null;
}
function getPosition(venues, archivedVenues, id) {
    const res = findPositionById([...venues, ...archivedVenues], id);
    if (res) {
        return {
            ...res,
            label: venues.length > 1 // TODO: Should this be based on only active venues, not all venues?
                ? `${res.venue.name} / ${res.department.name} / ${res.position.name}`
                : `${res.department.name} / ${res.position.name}`,
            color: getPositionColorFromDepartment(res.position, res.department),
        };
    }
    return null;
}
function getPositionColorFromDepartment(position, department) {
    if (position.color) {
        return position.color;
    }
    const color = (department && department.color) || "";
    return colors_1.colors[color] || color;
}
function getPositionColor(venues, position) {
    if (position.color) {
        return position.color;
    }
    const { department } = getDepartment(venues, position.departmentId);
    return getPositionColorFromDepartment(position, department !== null && department !== void 0 ? department : undefined);
}
//# sourceMappingURL=company.util.js.map